export default "__VITE_ASSET__Dgs0PpKW__"